// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSessionRevokeOneBody = {
  sessionId: string;
};

export type typeSessionRevokeOneOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { revokedCount: number };
};

export type typeSessionRevokeOneOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRevokeOneOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRevokeOneOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSessionRevokeOneBody = {
  type: "object",
  properties: { sessionId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["sessionId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSessionRevokeOne(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSessionRevokeOneBody);
  }

  return async function postSessionRevokeOne(
    payload: typeSessionRevokeOneBody,
  ): Promise<typeSessionRevokeOneOutput200 | typeSessionRevokeOneOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSessionRevokeOne" failed before calling the network. #bcfde9ac4a41`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#bcfde9ac4a41" },
        },
        data: null,
      } as typeSessionRevokeOneOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/session/revoke-one`,
      httpMethod: "POST",
      options,
    })) as typeSessionRevokeOneOutput200 | typeSessionRevokeOneOutput400;
  };
}
